// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"coursedownloads_wrapper__2MlET","headline":"coursedownloads_headline__WPw83","buttons":"coursedownloads_buttons__XIG0X"};